import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import {
	Box,
	InnerHeading,
	LazyImage,
	MainHeading,
	SpanStyled,
	SpanStyledB,
} from "../../ui/Elements";

import { useTranslation } from "react-i18next";
import i18n from "../../Languages/INEXT";

const Marquee = () => {
	const { t } = useTranslation();
	const text = t("marquee");

	return (
		<MarqueeWrapper className="marquee">
			{/* <div class="marquee__item">
			{t('marquee')}
			</div>
			
			<div class="marquee__item">
				{t('marquee')}
			</div> */}
			{/* <Box className="marquee-content">
                <span>
                    {t('marquee')}
                </span>
                <span>
                    {t('marquee')}
                </span>
            </Box> */}
			<Box className="marquee-track">
				<Box className="marquee-content">{text.repeat(10)}</Box>
				<Box className="marquee-content">{text.repeat(10)}</Box>
			</Box>
		</MarqueeWrapper>
	);
};

/* const MarqueeWrapper = styled.div`
	border: 2px solid red ;
	display: flex ;
	overflow: hidden ;
	white-space: nowrap ;
	width: 100% ;
	.marquee__item {
			animation-duration: 4s ;
			animation-iteration-count: infinite ;
			animation-name: marquee-content ;
			animation-timing-function: linear ;
			padding: 5px 15px 5px 15px ;
			font-family: var(--familyRbt);
			font-weight: var(--semiBold);
			color: var(--themeColor);
			font-size: 72px;
			body.rtl &{
				font-family: var(--arSemiBold);
				color: var(--themeColor);
				font-size: 72px;
				animation-name: marquee-content-ar ;
			}
		}
		.marquee:hover .marquee__item {
			animation-play-state: paused ;
		}

		
		@keyframes marquee-content {
			from {
				transform: translateX( 0% );
			}
			to {
				transform: translateX( -100% );
			}
		}
		@keyframes marquee-content-ar {
			from {
				transform: translateX( -100% );
			}
			to {
				transform: translateX( 0% );
			}
		}
` */

const MarqueeWrapper = styled.div`
  /* overflow: hidden;
	white-space: nowrap;
	width: 100%;
	background: #000;
	color: #fff;
	padding: 10px 0; */
  overflow: hidden;
  width: 100%;
body.rtl & {
	/* direction: rtl; */
}
  /* .marquee-content {
		display: inline-flex;
		animation: scroll 10s linear infinite;
	}

    .marquee-content span {
		padding-right: 50px;
		font-size: 18px;
    }

    @keyframes scroll {
		from {
			transform: translateX(0%);
		}
		to {
			transform: translateX(-50%);
		}
    } */
	.marquee-track {
		display: flex;
		width: max-content;
		animation: marquee 80s linear infinite;
		body.rtl & {
			animation: marqueear 80s linear infinite;
		}
	}

  	.marquee-content {
		white-space: nowrap;
		font-size: 18px;
		padding-right: 50px;
		font-family: var(--familyRbt);
		font-weight: var(--semiBold);
		color: var(--themeColor);
		font-size: 72px;
		body.rtl & {
			font-family: var(--arSemiBold);
			color: var(--themeColor);
			font-size: 72px;
			
		}
	}

	
	@keyframes marquee {
		0% {
		transform: translateX(0);
		}
		100% {
		transform: translateX(-50%);
		}
	}
	@keyframes marqueear {
		0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
	}
`;

export default Marquee;
